import { RegularPresentAcceptActivityPayrollFilesPage } from "@/features/regular-document/pages/acceptance-activity-document/RegularPresentAcceptActivityPayrollFiles";

const RegularPresentAcceptanceActivityPayrollFiles = () => {
  return <RegularPresentAcceptActivityPayrollFilesPage />;
};

export default RegularPresentAcceptanceActivityPayrollFiles;
